module.exports = __webpack_public_path__ + "img/CRC2_Myofibroblasts.a4a26227.png";